import React, {useEffect} from "react";
import {handleLoginByToken} from "helpers/User";
// import {useQuery} from "@apollo/client"

import {userContext} from "../context/User"


// import {Modal} from "app/components/common/Navigation/Modal/Modal";
// import {LoginForm} from "app/containers/backoffice/Login/LoginForm";
// import {handleLoginByToken} from "app/helpers/User"

import {useQuery} from "@apollo/client";
import {LoginForm} from "./common/User/Login/LoginForm";

import userProfileQuery from "graphql/User/query/userProfile"

export enum AuthTypeEnum {
  OPTIONAL= "OPTIONAL",
  REQUIRED= "REQUIRED",
}

export const AuthWrapper = (props: any) => {

  const {authType, Component, ...routerProps} = props

  const {data, loading} = useQuery(userProfileQuery, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "cache-and-network",
  });

  const {userProfile} = data || {}
  const isAuthenticated = !!userProfile

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get('id')
    const token = urlParams.get('token')
    if (token && id) {
      console.log("Trying to login via token")
      handleLoginByToken(id, token)
    }
  }, [userProfile])

  switch (authType) {

    case AuthTypeEnum.REQUIRED: {
      if (isAuthenticated) {
        return <userContext.Provider value={userProfile}><Component {...routerProps} /></userContext.Provider>
      }

      return <LoginForm loading={loading} />
    }

    // case "REQUIRED":
    case AuthTypeEnum.OPTIONAL: {
      return <userContext.Provider value={userProfile}>
        <Component
          {...routerProps}
        />
      </userContext.Provider>

    }
    default: {
      return <LoginForm loading={loading} />
    }
  }
}
